"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatSize = void 0;
var formatSize = function (total) {
    if (total <= 0) {
        return '0 B';
    }
    var i = Math.floor(Math.log(total) / Math.log(1024));
    var suffix = ['B', 'KB', 'MB', 'GB', 'TB'][i];
    if (i === 0)
        return "".concat(total, " ").concat(suffix);
    var result = total / Math.pow(1024, i);
    var decimals = Math.floor(result) * 100 - Math.floor(result * 100) ? 2 : 0;
    return "".concat(result.toFixed(decimals), " ").concat(suffix);
};
exports.formatSize = formatSize;
